import styled from "styled-components";

export const ButtonsContainer = styled.div`
    display: flex;
    justify-content: flex-end;
    align-items: center;
    margin-top: var(--spacer-M);

    & > * {
        margin: var(--spacer-XS);
    }
`;
